import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "global" }
const _hoisted_2 = { class: "skills-section" }
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "competencies-grid" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "projects-tag" }
const _hoisted_8 = { class: "feature-list" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "projects-tag" }
const _hoisted_11 = { class: "feature-list" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "projects-tag" }
const _hoisted_14 = { class: "feature-list" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "projects-tag" }
const _hoisted_17 = { class: "feature-list" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "projects-tag" }
const _hoisted_20 = { class: "feature-list" }
const _hoisted_21 = { class: "card-header" }
const _hoisted_22 = { class: "projects-tag" }
const _hoisted_23 = { class: "feature-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('skills.title')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('skills.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "comp-card ln-glass-teal card-border-teal",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseEnter('comp1'))),
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "mdi mdi-code-braces card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp1.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp1.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp1.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp1.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp1.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp1.li3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp1.li4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp1.li5')), 1)
          ])
        ], 32),
        _createElementVNode("div", {
          class: "comp-card ln-glass-terracotta card-border-terracotta",
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMouseEnter('comp2'))),
          onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mdi mdi-lightning-bolt-outline card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp2.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_10, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp2.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp2.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp2.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp2.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp2.li3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp2.li4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp2.li5')), 1)
          ])
        ], 32),
        _createElementVNode("div", {
          class: "comp-card ln-glass-stone card-border-stone",
          onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onMouseEnter('comp3'))),
          onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mdi mdi-server-network card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp3.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp3.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp3.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp3.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp3.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp3.li3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp3.li4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp3.li5')), 1)
          ])
        ], 32),
        _createElementVNode("div", {
          class: "comp-card ln-glass-beige card-border-beige",
          onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onMouseEnter('comp4'))),
          onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mdi mdi-database card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp4.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_16, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp4.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp4.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp4.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp4.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp4.li3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp4.li4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp4.li5')), 1)
          ])
        ], 32),
        _createElementVNode("div", {
          class: "comp-card ln-glass-teal card-border-teal",
          onMouseenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMouseEnter('comp5'))),
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_18, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mdi mdi-clipboard-text-play-outline card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp5.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_19, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp5.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp5.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_20, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp5.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp5.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp5.li3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp5.li4')), 1)
          ])
        ], 32),
        _createElementVNode("div", {
          class: "comp-card ln-glass-terracotta card-border-terracotta",
          onMouseenter: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onMouseEnter('comp6'))),
          onMouseleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "mdi mdi-account-group-outline card-icon" }, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('skills.comp6.title')), 1)
          ]),
          _createElementVNode("p", _hoisted_22, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('skills.comp6.projects')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('skills.comp6.projectsList')), 1)
          ]),
          _createElementVNode("ul", _hoisted_23, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp6.li1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp6.li2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.comp6.li3')), 1)
          ])
        ], 32)
      ])
    ])
  ]))
}